import { Node as TiptapNode, mergeAttributes } from '@tiptap/core';
import { keymap } from '@tiptap/pm/keymap';
import { ReactNodeViewRenderer } from '@tiptap/react';
import { NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import { CitationType } from 'api/citation/types';
import { CitationDataPopover } from './ui/citation-data-popover';
import { OnViewCitationSourceCallback } from './ui/types';

export const RlCitationName = 'RL_CITATION';

const CitationNodeView = ({ node, extension }: NodeViewProps) => {
  return (
    <NodeViewWrapper
      contentEditable={false}
      as="span"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle',
        lineHeight: 1,
        fontSize: '1em',
      }}
    >
      <CitationDataPopover
        label={node.attrs.label}
        citationId={node.attrs.citationUuid}
        citationType={node.attrs.citationType}
        onViewCitationSource={extension.options.onViewCitationSource}
      />
    </NodeViewWrapper>
  );
};

export type RlCitationOptions = {
  onViewCitationSource?: OnViewCitationSourceCallback;
};
export const RlCitation = TiptapNode.create<RlCitationOptions>({
  name: RlCitationName,

  group: 'inline',
  inline: true,
  atom: true,
  selectable: false,
  draggable: false,

  addAttributes() {
    return {
      citationUuid: {
        default: 1,
      },
      citationType: {
        default: CitationType.Meeting,
      },
      label: {
        default: '',
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: `span[data-type="${this.name}"]`,
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, {
        ['data-type']: this.name,
        contenteditable: 'false',
      }),
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(CitationNodeView);
  },

  addProseMirrorPlugins() {
    return [
      keymap({
        Backspace: (state: any) => {
          const { $cursor } = state.selection as any;

          if ($cursor) {
            const nodeBefore = $cursor.nodeBefore;

            if (nodeBefore && nodeBefore.type.name === this.name) {
              // Prevent deletion
              return true;
            }
          }

          return false;
        },
        Delete: (state: any) => {
          const { $cursor } = state.selection as any;

          if ($cursor) {
            const nodeAfter = $cursor.nodeAfter;

            if (nodeAfter && nodeAfter.type.name === this.name) {
              // Prevent deletion
              return true;
            }
          }

          return false;
        },
      }),
    ];
  },
});
